Shopify.Dev = Shopify.Dev || {};

Shopify.Dev.termsAndConditions = {
    loadPopup: function () {
        $('#terms-popup').addClass('unaccepted');
        $('.accept-btn').on('click', function () {
            $(this).parents('#terms-popup').removeClass('unaccepted');
            document.cookie = "acceptedTerms=true";
        });
    }
};

$( function () {
    // Show t&c modal if not previously accepted.
    var match = document.cookie.match(new RegExp('(^| )acceptedTerms=([^;]+)'));
    if (!match) Shopify.Dev.termsAndConditions.loadPopup();

    $('.open-dev_tools').on('click', function () {
        $.fancybox.open({
            src: '#dev_tools',
            type: 'inline'
        });
    });
});
